/**
 * Created by jacmai on 6/30/2017.
 */
define([
  "marionette",
  "messaging/messenger",
  "./responsePreviewView",
  "./responsePreviewModel",
  "modules/shared/responseEditorModal/responseEditorModalModule",
], function (
  Marionette,
  Messenger,
  ResponsePreviewView,
  ResponsePreviewModel,
  ResponseEditorModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "responsePreview";
      this.region = options.region;
    },
    show: function (conversationVariable) {
      const responsePreviewModel = new ResponsePreviewModel.responsePreview();
      this.view = new ResponsePreviewView.responsePreviewView({ model: responsePreviewModel });
      //set the response when loading the module or when the TP or locale changes
      this.view.on(
        "change:response show",
        function () {
          this._setResponse(conversationVariable, responsePreviewModel);
        },
        this,
      );

      this.listenTo(conversationVariable, "change:prompt", function () {
        this._setResponse(conversationVariable, responsePreviewModel);
      });

      this.view.on(
        "edit:response",
        function () {
          const conversationVariableId = conversationVariable.id;
          //open up the response editor modal and pass it the response
          Messenger.vent.trigger(
            "show:modal",
            ResponseEditorModalModule,
            {},
            {
              conversationVariable: conversationVariable,
              selectedTouchPoint: responsePreviewModel.get("selectedTouchPoint"),
              selectedLocale: responsePreviewModel.get("selectedLocale"),
            },
            {
              title: "topic.responseEditor.title",
              closeButton: false,
              closeOnBackgroundClick: false,
              modalHeight: "690px",
              modalWidth: "1000px",
              trackInteraction: {
                action: "Edit Conversation Variable",
                id: [
                  conversationVariableId,
                  responsePreviewModel.get("selectedTouchPoint"),
                  responsePreviewModel.get("selectedLocale"),
                ],
                idType: ["Conversation Variable", "TouchPoint", "Locale"],
                object: "Conversation Variable",
              },
            },
          );
        },
        this,
      );

      this.showRegion(this.view);
    },
    //Set the displayed response to the currently selected TP and locale
    _setResponse: function (conversationVariable, previewModel) {
      conversationVariable.getResponse(
        previewModel.get("selectedTouchPoint"),
        previewModel.get("selectedLocale"),
        function (response) {
          //update the response displayed in the preview window
          previewModel.set("response", response);
        },
      );
    },
  });
});
